// extracted by mini-css-extract-plugin
export var lg = "_1p-4";
export var md = "_1p-3";
export var sm = "_1p-2";
export var xs = "_1p-1";
export var xxs = "_1p-0";